import type theme from '#build/ui/textarea'
import type { DeepPartial } from '@nuxt/ui'
import { inputCompoundVariants, inputDefaultVariants, inputSlots, inputVariants } from './input'

const textarea: DeepPartial<typeof theme> = {
  slots: { ...inputSlots as any },
  variants: { ...inputVariants as any },
  compoundVariants: [...inputCompoundVariants as any],
  defaultVariants: { ...inputDefaultVariants as any },
}

export default textarea
